import { render, staticRenderFns } from "./insActivityParticipant.vue?vue&type=template&id=c4961ece&"
import script from "./insActivityParticipant.vue?vue&type=script&lang=js&"
export * from "./insActivityParticipant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports